import { render, staticRenderFns } from "./ITableTh.vue?vue&type=template&id=db57eee6&"
import script from "./ITableTh.vue?vue&type=script&lang=js&"
export * from "./ITableTh.vue?vue&type=script&lang=js&"
import style0 from "./ITableTh.vue?vue&type=style&index=0&id=db57eee6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports